/* Restore post-load whole-page preparation; sections still own playback. */
(() => {
  if (window.FEMedia) return;
  const entries = new Set();
  let frame = 0, backgroundReady = false, backgroundPending = false;
  const slow = () => navigator.connection?.saveData || /(^|-)2g$/.test(navigator.connection?.effectiveType || '');
  const rect = v => v.getBoundingClientRect();
  const displayed = v => v.isConnected && v.getClientRects().length && rect(v).height > 0;
  function poster(v) {
    if (!v.getAttribute('poster') && v.dataset.poster) v.poster = v.dataset.poster;
  }
  function load(v) {
    poster(v);
    v.muted = true; v.defaultMuted = true; v.playsInline = true;
    if (!v.getAttribute('src') && !v.querySelector('source[src]')) {
      const src = (innerWidth <= 749 ? v.dataset.mobileSrc : v.dataset.desktopSrc) || v.dataset.src;
      if (src) v.src = src;
      v.querySelectorAll('source[data-src]').forEach(s => { s.src = s.dataset.src; });
      if (!v.getAttribute('src') && !v.querySelector('source[src]')) return;
      v.preload = 'auto';
      try { v.load(); } catch (_) { return; }
    } else v.preload = 'auto';
    v.dataset.prepped = '1'; v.dataset.loaded = '1';
  }
  function pendingVideo() {
    for (const v of entries) {
      if (!v.isConnected) { entries.delete(v); continue; }
      if (!v.error && v.dataset.prepped !== '1') return v;
    }
  }
  function scheduleBackground() {
    if (!backgroundReady || backgroundPending || slow() || !pendingVideo()) return;
    backgroundPending = true;
    const step = () => {
      backgroundPending = false;
      if (slow()) return;
      const next = pendingVideo();
      if (next) load(next);
      // As before, start the next video without waiting for the previous download.
      if (next && next.dataset.prepped !== '1') entries.delete(next);
      scheduleBackground();
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(step, {timeout: 1200});
    else setTimeout(step, 800);
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(pump); }
  function pump() {
    frame = 0;
    for (const v of entries) {
      if (!v.isConnected) { entries.delete(v); continue; }
      if (!document.hidden && displayed(v) && rect(v).bottom > -600 && rect(v).top < innerHeight + 600) {
        poster(v);
        if (!slow() && !v.error && v.dataset.prepped !== '1') load(v);
      }
    }
    scheduleBackground();
  }
  function register(v) {
    if (!v) return;
    entries.add(v);
    scheduleBackground();
  }
  function prepare(v, urgent = false) {
    if (!v) return;
    register(v);
    load(v);
  }
  function scan() {
    document.querySelectorAll('video[data-src], video[data-lazy-video], video[data-fe-airdrop], video[data-mobile-src], video[data-desktop-src]').forEach(register);
    schedule();
  }
  function kickoff() {
    setTimeout(() => { backgroundReady = true; scan(); }, 1500);
  }
  window.FEMedia = {prepare, register, poster};
  addEventListener('scroll', schedule, {passive:true});
  addEventListener('resize', schedule, {passive:true});
  addEventListener('online', schedule);
  document.addEventListener('visibilitychange', schedule);
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  if (document.readyState === 'complete') kickoff(); else addEventListener('load', kickoff, {once:true});
})();
